module.exports = __webpack_public_path__ + "img/icon-16-right.cdd202c6.svg";